import { DarkTheme } from '@/theme/DarkTheme'

export const availableThemes = [
  DarkTheme,
]
